import types from "../../../../actionTypes";

export const UPDATE_USER = types("UPDATE_USER");
export const CLEAR_UPDATE_ERROR = types("CLEAR_UPDATE_ERROR");
